import { render, staticRenderFns } from "./CadastroFormSearchSelect.vue?vue&type=template&id=5c631101&scoped=true&lang=pug&"
import script from "./CadastroFormSearchSelect.vue?vue&type=script&lang=js&"
export * from "./CadastroFormSearchSelect.vue?vue&type=script&lang=js&"
import style0 from "./CadastroFormSearchSelect.vue?vue&type=style&index=0&id=5c631101&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c631101",
  null
  
)

export default component.exports